import React, { useState, useEffect, useContext } from "react";
import {
    CardElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";

import { FaArrowLeft } from "react-icons/fa6";
import InputMask from "react-input-mask";
import api from '../../services/api';

import AuthContext from '../../contexts/auth';
import LanguageContext from '../../contexts/language';

export default function CheckoutForm(props) {

    const { id, price, name, email, phone, onPrev, onSubmit, getId } = props;
    const { language } = useContext(LanguageContext);
    const region = localStorage.getItem('region');
    const lang = localStorage.getItem('language');

    const [succeeded, setSucceeded] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [clientSecret, setClientSecret] = useState('');
    const [clientToken, setClientToken] = useState('');
    const stripe = useStripe();
    const elements = useElements();
    const [billingDetails, setBillingDetails] = useState({
        email,
        phone,
        name,
    });

    const { token } = useContext(AuthContext);
    const config = {
        headers: {
            'Authorization':`Bearer ${token}`,
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json',
        }
    };

    async function loadPage(){
        try{
            const response = await api.post('/create-stripe', {price, id});
            setClientSecret(response.data.clientSecret);
            setClientToken(response.data.stripe_id);
            getId(response.data.stripe_id);
            localStorage.setItem('stripe_id', response.data.stripe_id);
        }catch(res){
            console.log(res);
        }
    }

    useEffect(() => {
        loadPage();
    }, [price]);

    const cardStyle = {
        iconStyle: 'default',
        style: {
            base: {
                iconColor: "#4e4a4d",
                color: "#4e4a4d",
                fontFamily: 'Montserrat, Helvetica Neue, Arial, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "uppercase",
                "::placeholder": {
                    color: "#aaa"
                }
            },
            invalid: {
                color: "#e74c3c",
                iconColor: "#e74c3c"
            }
        }
    };

    const handleChange = async (event) => {
        setDisabled(event.empty);
        setError(event.error ? event.error.message : "");
    };

    const handleSubmit = async ev => {
        ev.preventDefault();
        setProcessing(true);

        const payload = await stripe.confirmCardPayment(clientSecret, {
            receipt_email: email,
            payment_method: {
                card: elements.getElement(CardElement),
                billing_details: billingDetails,
            }
        });

        if(payload.error) {
            setError(`${payload.error.message}`);
            setProcessing(false);
        } else {
            onSubmit();
        }
    };
    
    return (
        <>
            <CardElement id="card-element" options={cardStyle} onChange={handleChange} />
            <div className="alert alert-info mt-2">
                <strong>{lang==='pt' ? 'Atenção' : lang==='es' ? 'Importante' : 'Important'}</strong><br />
                {lang==='pt' ? 'O nome que aparecerá em sua fatura será:' : lang==='es' ? 'El cargo aparecerá en su estado de cuenta a nombre de:' : 'The charge will appear on your statement as:'} <strong>Tustin</strong>
            </div>
            <div className="mt-30 mb-0 d-btns w-auto">
                <a href="javascript:;" onClick={() => onPrev(5)} className="btn-send d-prev bg_color_4">
                    <FaArrowLeft />
                    <span>{language.prev}</span>
                </a>
                <a
                    disabled={processing || disabled || succeeded || billingDetails.phone==''}
                    id="submit"
                    onClick={handleSubmit}
                    href="javascript:;"
                    className={`btn-send d-next bg_color_4 ${ processing ? 'loading' : '' }`}
                >
                    {language.send} {language.inscricao}
                </a>
            </div>
            {error &&
            <div className="error mt-20 mb-0">{error}</div>}
            
            {processing &&
            <div className="row">
                <div className="m-auto text-center">
                    <div className="loader-btn mt-4">
                        <div className="spinner-content"><div className="bt-spinner mini"></div></div>
                        <div className="spinner-text">{language.form_capture}</div>
                    </div>
                </div>
            </div>}
        </>
    );
}
